module.exports = __webpack_public_path__ + "img/article.ff20b7af.svg";